import React from 'react'
import { useForm } from 'react-hook-form'
import './Advertise2.css'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'


export default function Advertise2() {


    return (
        <Container>
            <Row>
                <Col md className="leftArea">
                    <h1 style={{fontSize: '450%', color: 'rgb(29, 185, 84)', padding: '5%' }}>Ad</h1>
                    <h1 style={{fontSize: '450%', color: 'rgb(29, 185, 84)'}}>Options</h1>
                    <h3>In-app display ads for $70 per month</h3>
                    <h3>Push notifications for $0.25 per user</h3>
                    <p style={{ padding: '10%' }}>We offer the cheapest most effective way to advertise to students with advertising options that meet students in the flow of their everyday lives. Push notifications while they're checking their phones. In app display ads while they're buying party tickets.</p>
                    <a href={`mailto:business.xsell@gmail.com?&subject=Advertising%20Inquiry&body=`} rel="EMAIL">Email us</a>
                </Col>
                <Col md>
                    <Row>
                        <Col md>
                            <Image src={require('../../assets/Webp.net-resizeimage.jpg')} />
                        </Col>
                        <Col md> 
                            <Image src={require('../../assets/Screenshot_20200405-175454_XSell_Restart.jpg')} />
                        </Col>
                    </Row>
                    <Row>
                        <Col />
                        <Col xs="auto">
                            <Image src={require('../../assets/ad_notification.PNG')} />
                        </Col>
                        <Col />
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}